
































































import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import Back from '@modules/ui/buttons/Back'
import Trigger from '@modules/ui/triggers/Trigger'
import ActivationResourceList from '@superUI/ResourceList/ActivationResourceList'

import DiscountTable from '@superUI/Pricing/DiscountTable'
import UpdatePricingModelDiscountTriggerModal from '@triggers/Pricing/UpdatePricingModelDiscountTriggerModal'
import RemovePricingModelDiscountTriggerModal from '@triggers/Pricing/RemovePricingModelDiscountTriggerModal'

settings =
  name: 'BrandShow'
  components: {
    SuperContainerView,
    Back,
    Trigger,
    ActivationResourceList,
    DiscountTable,
    UpdatePricingModelDiscountTriggerModal,
    RemovePricingModelDiscountTriggerModal
  }

  resources:
    item:
      resourceName: 'brand'
      slug: 'brands/:brandId'
    activations:
      resourceName: 'activation'
      slug: 'brands/:brandId/activations'
      infinityScroll: true

  vue:
    props: ['brandId']

    data: ->
      memberNoteModal:
        modalOptions:
          title: 'Add Member Note'
          inputField:
            label: 'Member Note'
            type: 'el-input'
            model: 'note'
          button:
            label: 'Add'
      superNoteModal:
        modalOptions:
          title: 'Add Super Note'
          inputField:
            label: 'Super Note'
            type: 'el-input'
            model: 'note'
          button:
            label: 'Add'

    computed:
      memberNoteTriggerResource: ->
        { key: 'item', triggerName: 'add_member_note', component: this }
      superNoteTriggerResource: ->
        { key: 'item', triggerName: 'add_super_note', component: this }

      memberNotePayload: ->
        payload =
          options:
            note: ""
        payload
      superNotePayload: ->
        payload =
          options:
            note: ""
        payload

      discountTable: -> @ctxDiscountTable(@item)
      actionsForPricingModelDiscount: ->
        {
          @hiUpdatePricingModelDiscountTrigger,
          @hiRemovePricingModelDiscountTrigger
        }

    methods:
      fetchResource: (state, resourceKey, data = {}, options={}) ->
        @fetchInfinity(state, resourceKey, data, options)

      onItemAddMemberNote: -> @fetch('item')
      onItemAddSuperNote: -> @fetch('item')

      hiUpdatePricingModelDiscountTrigger: (pricingModel, discount) ->
        payloadOptions = { pricing_model: pricingModel }
        modalOptions = { pricing_model: pricingModel, discount }
        @$refs.updatePricingModelDiscountTrigger.fire(payloadOptions, modalOptions)
      onItemUpdatePricingModelDiscount: (data, response) ->
        @$refs.updatePricingModelDiscountTrigger.close()
        @fetch('item')

      hiRemovePricingModelDiscountTrigger: (pricingModel) ->
        payloadOptions = { pricing_model: pricingModel }
        modalOptions = { pricing_model: pricingModel }
        @$refs.removePricingModelDiscountTrigger.fire(payloadOptions, modalOptions)
      onItemRemovePricingModelDiscount: (data, response) ->
        @$refs.removePricingModelDiscountTrigger.close()
        @fetch('item')
      
    watch:
      $route: ->
        @fetchAllResources()

export default VueOptions.vue settings
